import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, ArrowRight } from 'lucide-react';
import { locations } from '../data/content';
import { Button } from './ui/button';

export const LocationsSection = () => {
  return (
    <section data-testid="locations-section" className="section-spacing bg-white relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-orange/5 rounded-full blur-3xl" />
      
      <div className="section-container relative z-10">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <span className="inline-block px-4 py-2 bg-blue-100 text-blue-600 rounded-full text-sm font-semibold mb-4">
            Our Residences
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 font-['Outfit']">
            Prime <span className="text-coral">Locations</span>
          </h2>
          <p className="mt-4 text-slate-600 text-lg">
            Multiple residences conveniently located for your academic success.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {locations.map((location) => (
            <div
              key={location.id}
              data-testid={`location-card-${location.id}`}
              className={`group bg-white rounded-2xl overflow-hidden border transition-all shadow-lg hover:shadow-xl ${
                location.status === 'coming-soon' 
                  ? 'border-yellow-300 hover:border-yellow-400' 
                  : 'border-orange-100 hover:border-coral/50'
              }`}
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={location.image}
                  alt={location.name}
                  className={`w-full h-full object-cover ${location.status === 'coming-soon' ? 'opacity-80' : ''} img-zoom group-hover:scale-110`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 to-transparent" />
                <div className="absolute bottom-3 left-3 right-3">
                  {location.status === 'coming-soon' ? (
                    <span className="inline-block px-3 py-1 rounded-full text-xs font-semibold text-yellow-900 bg-yellow-400 animate-pulse">
                      Coming Soon
                    </span>
                  ) : (
                    <span
                      className={`inline-block px-3 py-1 rounded-full text-xs font-semibold text-white ${
                        location.color === 'orange' ? 'bg-coral' : 'bg-blue-600'
                      }`}
                    >
                      {location.color === 'orange' ? 'Popular' : 'Available'}
                    </span>
                  )}
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-lg font-bold text-slate-900 font-['Outfit'] mb-1">
                  {location.name}
                </h3>
                <p className="text-slate-600 text-sm mb-2">{location.description}</p>
                <div className="flex items-start gap-2 text-slate-500 mb-4">
                  <MapPin className="w-4 h-4 text-coral mt-0.5 shrink-0" />
                  <span className="text-xs">{location.street}, {location.city}</span>
                </div>
                {location.status === 'coming-soon' ? (
                  <Button
                    disabled
                    className="w-full bg-yellow-100 text-yellow-700 rounded-full font-semibold cursor-not-allowed"
                  >
                    In Progress
                  </Button>
                ) : (
                  <Link to="/contact">
                    <Button
                      data-testid={`location-view-btn-${location.id}`}
                      className="w-full bg-gradient-to-r from-coral to-orange hover:from-coral-dark hover:to-coral text-white rounded-full font-semibold transition-all shadow-lg shadow-coral/25"
                    >
                      Book Viewing
                      <ArrowRight className="w-4 h-4 ml-2" />
                    </Button>
                  </Link>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
